import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { NgChartsModule } from 'ng2-charts';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { SliderModule } from 'primeng/slider';
import { TabViewModule } from 'primeng/tabview';
import { FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTabsModule } from '@angular/material/tabs'
import { MatTableModule } from '@angular/material/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { UiSwitchModule } from 'ngx-ui-switch';
import { GoogleMapsModule } from '@angular/google-maps';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SHARED_COMPONENTS, SHARED_ENTRY_COMPONENTS } from "./components";
import { SHARED_ELEMENTS, SHARED_ENTRY_ELEMENTS } from "./elements";
import { SHARED_FORMS } from "./forms";
import { CAMPAIGNS } from "./campaigns"
import { ColorSketchModule } from 'ngx-color/sketch';
import { EditorModule } from 'primeng/editor';
import { CheckboxModule } from 'primeng/checkbox';
import { KeyFilterModule } from 'primeng/keyfilter';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxIntlTelInputModule } from '@capgo/ngx-intl-tel-input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { PipesModule } from '../core/pipes/pipes.module';
import { DataDeletionFormComponent } from './forms/data-deletion-form/data-deletion-form.component';
import { GenerateReplyComponent } from './components/generate-reply/generate-reply.component';
import { ContactExportComponent } from './components/contact-export/contact-export.component';
import { ReviewExportComponent } from './components/review-export/review-export.component';
import { ExportDateRangeComponent } from './components/export-date-range/export-date-range.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AiAutoReplySettingsComponent } from './components/ai-auto-reply-settings/ai-auto-reply-settings.component';
// PrimeNG imports
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

const SHARED_MODULES: any[] = [
    NgbModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    DropdownModule,
    SliderModule,
    InputSwitchModule,
    UiSwitchModule,
    FormsModule,
    TextMaskModule,
    NgxPermissionsModule,
    DragDropModule,
    MatTabsModule,
    MatTableModule,
    ColorSketchModule,
    EditorModule,
    CheckboxModule,
    RadioButtonModule,
    MultiSelectModule,
    KeyFilterModule,
    NgxIntlTelInputModule,
    MatStepperModule,
    MatIconModule,
    GooglePlaceModule,
    PipesModule,
    DialogModule,
    ButtonModule,
    InputTextModule
];

@NgModule({
    imports: [
        ...SHARED_MODULES,
        NgChartsModule.forRoot(),
        CommonModule,
        TranslateModule,
        NgxDaterangepickerMd.forRoot(),
        NgCircleProgressModule.forRoot({}),
        GoogleMapsModule,
        CarouselModule,
        BsDatepickerModule.forRoot(),
        ImageCropperModule,
    ],
    declarations: [
        ...SHARED_COMPONENTS,
        ...SHARED_ELEMENTS,
        ...SHARED_FORMS,
        ...CAMPAIGNS,
        ContactExportComponent,
        ReviewExportComponent,
        ExportDateRangeComponent,
        DataDeletionFormComponent,
        GenerateReplyComponent,
        AiAutoReplySettingsComponent
    ],
    entryComponents: [
        ...SHARED_ENTRY_COMPONENTS,
        ...SHARED_ENTRY_ELEMENTS,
        ReviewExportComponent
    ],
    exports: [
        ...SHARED_MODULES,
        ...SHARED_COMPONENTS,
        ...SHARED_ELEMENTS,
        ...SHARED_FORMS,
        ...CAMPAIGNS,
        TranslateModule,
        GoogleMapsModule,
        NgChartsModule,
        NgCircleProgressModule,
        AiAutoReplySettingsComponent
    ],
    providers: [
    ],
    schemas: [NO_ERRORS_SCHEMA]
})
export class SharedModule { }
